/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Runtime posture requested by a construction/deployment path.
 */
export enum StrategyPosture {

    Backtest = 'backtest',

    Paper = 'paper',

    Sandbox = 'sandbox',

    Shadow = 'shadow',

    LiveCanary = 'live_canary',

    Live = 'live'
}
